/*
 * @Author: cn1994
 * @Date: 2023-02-14 11:10:58
 * @LastEditors: cn1994
 * @LastEditTime: 2023-10-13 15:34:37
 * @Description: 全局的图片url配置
 */

export const urls = {
  // 试听学员图标
  auditionStudentIcon: 'https://cdnws.51tyty.com/lstyty/file/2023/02/14/447838fd0646e658bf22f9d8c7ca21cf.png',
  // 默认用户头像
  userDefaultAvatar: 'https://cdnws.51tyty.com/lstyty/file/2023/02/21/a8187c95f6e671432b6d5a8b0fc40be3.png',
  // App自主学习板块封面上传图标
  appLearnUploadIcon: 'https://cdnws.51tyty.com/lstyty/file/2023/03/21/df239f2aeac8de18e93e0a1e2ce8941b.png',
  // App自主学习板块封面删除图标
  appLearnDeleteIcon: 'https://cdnws.51tyty.com/lstyty/file/2023/03/21/d934c819993148a2380a3a423e3b33bf.png',
  // App启动页选中按钮
  appStartupCheckedIcon: 'https://cdnws.51tyty.com/lstyty/file/2023/03/22/40adafba28ec1993e8a50518060afa27.png',
  // App启动页Pad模型图
  appStartupPad: 'https://cdnws.51tyty.com/lstyty/file/2024/08/30/2ffeeeadd46ced77914aedeee3f384e6.png',
  // App启动页手机模型图
  appStartupIphone: 'https://cdnws.51tyty.com/lstyty/file/2024/08/29/bad1f499dc2faea7fa3dd0046ce55e34.png',
  // 圆的白底的填充钩
  whiteCircleFillTick: 'https://cdnws.51tyty.com/lstyty/file/2024/08/07/83c8dd908e0970da302e71d5910bec5c.png',
  // 锁
  lock: 'https://cdnws.51tyty.com/lstyty/file/2023/05/16/b15692587cd34a6c6bc8342ecc695f4b.png',
  // 工作台待办提醒缺省图
  indexPageEmpty: 'https://cdnws.51tyty.com/lstyty/file/2023/07/18/f07aa62d95d186a0c323f42df59de435.png',
  // 工作台待办背景图-早上
  indexPageMorning: 'https://cdnws.51tyty.com/lstyty/file/2023/07/19/0dfe3a70dc16b33e3c61f927e36998ca.png',
  // 工作台待办背景图-中午
  indexPageNoon: 'https://cdnws.51tyty.com/lstyty/file/2023/07/19/3594f4a42e11f2a43819532a45801ccf.png',
  // 工作台待办背景图-晚上
  indexPageNight: 'https://cdnws.51tyty.com/lstyty/file/2023/07/19/28c1e466265ee8d5c1bbe3b025abef96.png',
  //登录页企业微信图片
  // wechatImagelogin: "https://cdnws.51tyty.com/lstyty/file/2023/08/16/b0413438ed941d34426789b3c39d0e41.png",
  wechatImagelogin: "https://cdnws.51tyty.com/lstyty/file/2024/05/23/88da0e485c60d4207c698ea936883ffd.png",
  //app版本切换2.0的图片
  apptwozero:'https://cdnws.51tyty.com/lstyty/file/2023/08/30/d442be20e3ac9c9bbf4243d7cb43aebf.png',
  //app版本切换3.0的图片
  appthreezero:'https://cdnws.51tyty.com/lstyty/file/2023/08/30/72fea34f26575f15ff29a7c93509ebe2.png',
  //app版本切换3.0plus的图片
  appthreezeroPlus:'https://cdnws.51tyty.com/lstyty/file/2023/10/13/6cff06b8c4d3cf9a48f3f3d655e1f714.png',
  // app首页-西瓜的默认图
  watermelonxgXxdt: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/7f2ecdc110695365e65e06342628699f.png',
  watermelonxgSk: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/9743dfb5467bdf7decc35218d2e6e159.png',
  watermelonxgKwzt: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/d79f32e5993c628c7251b7d9fab1e8d5.png',
  watermelonxgKcxq: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/f04dd0e861ca160faa9173c1e550e406.png',
  watermelonxgXxtz: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/38e17c6d4ac6b07ddb6fd4dbd9a4ab1d.png',
  watermelonxgCykj: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/bfb4508309a2fc266cfa4cee1916045b.png',
  // 直播配色-浅色系
  roomColorStandard: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomColorStandard.png',
  // 直播配色-深色系
  roomColorCartoon: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomColorCartoon.png',
  // 直播布局1
  roomLayoutSpeaker: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomLayoutSpeaker.png',
  // 直播布局2
  roomLayoutAround: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomLayoutAround.png',
  // 直播布局3
  roomLayoutList: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomLayoutList.png',
  // 直播布局4
  roomLayoutTop: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomLayoutTop.png',
  // 直播布局5
  roomLayoutVideo: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomLayoutVideo.png',
  // 直播布局使用帮助
  roomLayoutHelp: 'https://cdnws.51tyty.com/business/ossManagement/business_default_img/roomLayoutHelp.jpg',
  // 登陆已关停账号提示小程序码
  loginLingShiYunQr: 'https://cdnws.51tyty.com/lstyty/file/2023/08/30/9644560eb0d4e67bb5ad2cc47ce209f3.jpg',
  //背景图
  appBackPhotoUrl: 'https://cdnws.51tyty.com/lstyty/file/2021/12/30/2d0b3916a11ef8a2f2b9f1dab8c499a7.png',
  //直播中心购买直播套餐互动直播
  payLiveUrl:'https://cdnws.51tyty.com/lstyty/file/2023/11/08/2c39c24c7b3e0ef451491ec2424935fd.png',
  //直播中心购买直播套餐大课
  payLiveBigClassUrl:'https://cdnws.51tyty.com/lstyty/file/2023/11/08/d6d4f90b475f55247953f7b4db6f3b77.png',
  //首页工作台机器人图片
  // bootImageUrl:'https://cdnws.51tyty.com/lstyty/file/2024/03/04/74bf8012fe3c5411378940350abd4248.png',
  bootImageUrl:'https://cdnws.51tyty.com/lstyty/file/2024/06/04/67812595c474a2ed79586a0242a6bda3.gif',
  bootImageUrlRight:'https://cdnws.51tyty.com/lstyty/file/2024/03/07/0fbf9a8c6ff9e724b96eac3cbfe65c64.png',
  //导入学员基本信息
  importBaseInfo:'https://cdnws.51tyty.com/lstyty/file/2024/03/15/7afc33f05292b593c1bd93c16d4d505a.png',
  //导入学员购课信息
  importBuyClass:'https://cdnws.51tyty.com/lstyty/file/2024/03/15/0a4d82f5a1606063fd9e9e1bcf60b027.png',
  //导入第三方学员
  importThreeStutent:'https://cdnws.51tyty.com/lstyty/file/2024/03/15/23c572244d50abbec016b0d2a6c7aaf2.png',
  //主题背景色新标签
  newTagColor:'https://cdnws.51tyty.com/lstyty/file/2024/08/07/d084ef0b7cf972a022f3fecb3d0fd79c.png',
  //登录页电脑icon
  loginComputer:'https://cdnws.51tyty.com/lstyty/file/2024/08/27/450cd8bab1132c8f01fca29e639089c2.png',
  //登录页文件夹icon
  loginFile:'https://cdnws.51tyty.com/lstyty/file/2024/08/27/dc58d56faae10acbf53d915653e70fd3.png',
  //课时卡的icon
  courseCardIcon:'https://cdnws.51tyty.com/business/ossManagement/business_default_img/course_card_icon.png',
  // 课程样式的icon
  courseIcon:'https://cdnws.51tyty.com/business/ossManagement/business_default_img/course_icon.png',
  //课程订单中已消费金额的icon
  consumedAmount:'https://cdnws.51tyty.com/lstyty/file/2024/09/30/5d169df79debcf6e5e151743376eeeb9.png',
  //首页工作台学习机
  learningMachine:'https://cdnws.51tyty.com/lstyty/file/2025/03/17/d9c0f568d5eb2df9b56321e1e56e2c34.png',
  // 性别男
  sexMan:'https://cdnws.51tyty.com/business/ossManagement/business_default_img/gender_man.png',
  // 性别女
  sexWoman:'https://cdnws.51tyty.com/business/ossManagement/business_default_img/gender_woman.png',
}

export default urls
